import styled from 'styled-components';
import { Flex } from 'grid-styled';
import media from 'utils/media';

const Content = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100%;
  padding-top: 0rem;
  padding-bottom: 0rem;
  box-sizing: border-box;
  margin-bottom: 0px;
  margin-top: ${props => (props.notHero ? '-1rem' : '0px')};
  ${media.customLG.css`
  margin-top: 0;
  max-width: 65rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
  `}
`;

export default Content;



// WEBPACK FOOTER //
// ./src/components/NYCMeetUpLanding/components/Content.js